import {
  DEFAULT_CREDIT_COMMISSION_PERCENTAGE,
  DEFAULT_NO_LIMIT_COMMISSION_PERCENTAGE,
} from '../shared/Constants';
import { createIntl, createIntlCache, defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  messageToOwnerFirstLine: {
    id: 'attrs.owner.message.first-line',
    defaultMessage: 'The commissions and discounts connected to your GP Agreement (attached) are:',
  },
  messageToOwnerSecondLine: {
    id: 'attrs.owner.message.second-line',
    defaultMessage: '- Your commission on Credits sold by you to your Clients is {creditCommissionPercentage}%.',
  },
  messageToOwnerThirdLine: {
    id: 'attrs.owner.message.third-line',
    defaultMessage:
      '- Your commission on NoLimit subscriptions sold by you to your Clients is {noLimitCommissionPercentage}%.',
  },
  messageToOwnerFourthLine: {
    id: 'attrs.owner.message.fourth-line',
    defaultMessage:
      '- Your commission on SuperMatch Credits purchased by your Clients is {superMatchCreditsCommissionPercentage}%.',
  },
  messageToOwnerFifthLine: {
    id: 'attrs.owner.message.fifth-line',
    defaultMessage:
      '- Your Discount on SuperMatch Credits purchased by yourself is {superMatchCreditsCommissionPercentage}%.',
  },
});

const useGpMessageToOwner = () => {
  const { formatMessage } = useIntl();

  const buildDefaultMessageToOwner = () => {
    return `${formatMessage(messages.messageToOwnerFirstLine)}
        ${formatMessage(messages.messageToOwnerSecondLine, {
          creditCommissionPercentage: DEFAULT_CREDIT_COMMISSION_PERCENTAGE,
        })}    
        ${formatMessage(messages.messageToOwnerThirdLine, {
          noLimitCommissionPercentage: DEFAULT_NO_LIMIT_COMMISSION_PERCENTAGE,
        })}
      `;
  };

  const buildMessageToOwner = async (
    locale,
    creditCommissionPercentage,
    noLimitCommissionPercentage,
    callback,
  ) => {
    const response = await fetch(`/apps/client/translations/${locale}.json`);
    const data = await response.json();

    const cache = createIntlCache();

    const intl = createIntl(
      {
        locale,
        messages: data,
      },
      cache,
    );

    const message = `${intl.formatMessage(messages.messageToOwnerFirstLine)}
          ${intl.formatMessage(messages.messageToOwnerSecondLine, { creditCommissionPercentage })}
          ${intl.formatMessage(messages.messageToOwnerThirdLine, { noLimitCommissionPercentage })}
        `;

    callback(message);
  };

  return {
    buildDefaultMessageToOwner,
    buildMessageToOwner,
  };
};

export default useGpMessageToOwner;
